// AdminSchema.js
// Matches the same shape/style as PermissionGroupSchema.js

export const adminFormSchema = [
  {
    id: "id",
    dataType: "integer",
    shownOnForm: false,
    label: "ID",
    value: 0,
    isRequired: false,
    fieldType: "textfield",
  },
  {
    id: "name",
    dataType: "Text",
    shownOnForm: true,
    label: "Name",
    value: "",
    isRequired: true,
    maxChar: 255,
    fieldType: "textfield",
    pattern: /^[A-Za-z]+(?:[ '-][A-Za-z]+)+$/,
    patternMessage: "Invalid name. Please enter both the first and last name",
  },
  {
    id: "phone",
    dataType: "Phone",
    shownOnForm: true,
    label: "Phone",
    value: "",
    isRequired: true,
    maxChar: 30,
    fieldType: "textfield",
    pattern: /^\d{4}[0-9]{8}$/,
    patternMessage: "Invalid phone number. Should be in the format CCCDDDDDDDDD e.g 256701123456",
  },
  {
    id: "email",
    dataType: "Email",
    shownOnForm: true,
    label: "Email",
    value: "",
    isRequired: true,
    maxChar: 255,
    fieldType: "textfield",
    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    patternMessage: "Invalid email address.",
  },
  {
    id: "status",
    dataType: "Text",
    shownOnForm: true,
    label: "Status",
    value: "active",
    isRequired: true,
    maxChar: 50,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: () => [
      { value: "active", label: "Active" },
      { value: "suspended", label: "Suspended" },
      { value: "inactive", label: "Inactive" },
    ],
  },
  {
    id: "gender",
    dataType: "Text",
    shownOnForm: true,
    label: "Gender",
    value: "",
    isRequired: true,
    maxChar: 20,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: () => [
      { value: "MALE", label: "Male" },
      { value: "FEMALE", label: "Female" },
      { value: "OTHER", label: "Other" },
    ],
  },
  {
    // password required only on create (enforced in your Admins.js validateCreatePassword)
    id: "password",
    dataType: "password",
    shownOnForm: true,
    label: "Password",
    value: "",
    isRequired: false,
    maxChar: 255,
    fieldType: "password",
  },
  {
    id: "passwordResetStatus",
    dataType: "Text",
    shownOnForm: true,
    label: "Password Reset Status",
    value: "require",
    isRequired: true,
    fieldType: "select",
    textValue: "label",
    valueKey: "value",
    options: () => [
      { value: "require", label: "Require" },
      { value: "done", label: "Done" },
    ],
  },

  // -------- NEW: Permission Groups (multiselect) --------
  {
    id: "permissionGroups",
    dataType: "Array",
    shownOnForm: true,
    isRequired: false,
    label: "Permission Groups",
    value: [],
    fieldType: "multiselect",
    textValue: "name",
    // expects options injected like: { permissionGroups: [...] }
    options: ({ permissionGroups }) => permissionGroups || [],
  },

  // -------- NEW: Direct Permissions (multiselect) --------
  {
    id: "permissions",
    dataType: "Array",
    shownOnForm: true,
    isRequired: false,
    label: "Direct Permissions",
    value: [],
    fieldType: "multiselect",
    textValue: "name",
    // expects options injected like: { permissions: [...] }
    options: ({ permissions }) => permissions || [],
  },
];

export const adminRecord = {
  id: 0,
  name: "",
  phone: "",
  email: "",
  status: "active",
  gender: "",
  password: "",
  passwordResetStatus: "require",
  permissionGroups: [],
  permissions: [],
};
